import React, { useState } from 'react';
import moment from 'moment';
import { fmtPct } from '../shared/format';

const PAGE = 50;

const CHIP = {
  logged_in: ['Logged in', 'bg-green-50 text-green-800'],
  on_leave: ['On leave', 'bg-sky-50 text-sky-800'],
  absent: ['Absent', 'bg-red-50 text-red-700'],
  not_logged_in: ['Not logged in', 'bg-amber-50 text-amber-800'],
  off: ['Off', 'bg-gray-100 text-gray-700']
};

/**
 * One row per employee. For a single day it shows that day's status and
 * check-in time; for a range, the person-day counts.
 */
const EmployeeTable = ({ rows, singleDay, notInLabel }) => {
  const [shown, setShown] = useState(PAGE);
  const visible = rows.slice(0, shown);

  return (
    <div className="bg-white rounded-2xl shadow-md overflow-x-auto">
      <table className="w-full min-w-[860px] border-collapse text-sm">
        <thead>
          <tr className="bg-slate-100 text-left text-gray-700">
            <th className="px-5 py-3.5 font-semibold">Employee</th>
            <th className="px-4 py-3.5 font-semibold">Department</th>
            {singleDay ? (
              <>
                <th className="px-4 py-3.5 font-semibold">Status</th>
                <th className="px-4 py-3.5 font-semibold">Check-in</th>
              </>
            ) : (
              <th className="px-4 py-3.5 font-semibold">Logged in / expected days</th>
            )}
            <th className="px-4 py-3.5 font-semibold">Calls done / assigned</th>
            <th className="px-5 py-3.5 font-semibold">Tasks done / due</th>
          </tr>
        </thead>
        <tbody>
          {visible.map((row) => {
            const [chipText, chipClass] = CHIP[row.attendanceStatus] || CHIP.off;
            return (
              <tr key={row.userId} className="border-t border-gray-200">
                <td className="px-5 py-3.5 font-semibold text-gray-900">{row.name}</td>
                <td className="px-4 py-3.5 text-gray-700">{row.vertical || '—'}</td>
                {singleDay ? (
                  <>
                    <td className="px-4 py-3.5">
                      <span className={`px-2.5 py-1 rounded-full text-[13px] font-semibold ${chipClass}`}>
                        {row.attendanceStatus === 'not_logged_in' ? notInLabel : chipText}
                      </span>
                    </td>
                    <td className="px-4 py-3.5">{row.checkIn ? moment(row.checkIn).format('h:mm A') : '—'}</td>
                  </>
                ) : (
                  <td className="px-4 py-3.5">
                    {row.attendance.loggedIn} / {row.attendance.expected}{' '}
                    <span className="text-gray-600">({fmtPct(row.attendance.loggedInPct)})</span>
                  </td>
                )}
                <td className="px-4 py-3.5">
                  {row.calls.completed} / {row.calls.assigned}{' '}
                  <span className="text-gray-600">({fmtPct(row.calls.pct)})</span>
                </td>
                <td className="px-5 py-3.5">
                  {row.tasks.completed} / {row.tasks.due}{' '}
                  <span className="text-gray-600">({fmtPct(row.tasks.pct)})</span>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      {rows.length > shown && (
        <div className="p-4 border-t border-gray-200 flex justify-between items-center text-sm text-gray-700">
          <span>
            Showing {shown} of {rows.length}
          </span>
          <button
            type="button"
            onClick={() => setShown((n) => n + PAGE)}
            className="min-h-[40px] px-4 rounded-md border border-gray-300 font-semibold hover:bg-gray-50"
          >
            Show more
          </button>
        </div>
      )}
    </div>
  );
};

export default EmployeeTable;
